import { createFeature, createReducer } from '@ngrx/store';

import { cancelPayLinkDialogReducers } from './cancel-pay-link-dialog.reducer';
import { cancelPayLinkDialogInitialState } from './cancel-pay-link-dialog.state';

export const cancelPayLinkDialogFeature = createFeature({
    name: 'cancelPayLinkDialog',
    reducer: createReducer(cancelPayLinkDialogInitialState, ...cancelPayLinkDialogReducers),
});
